module.exports = __webpack_public_path__ + "img/post.3b678cd6.gif";